import axios from "../../../../api/axios";

import { User } from "../../../types";
import { SubscriptionPlanOption } from "../../types/plans";

type UserSettings = {
  dailyInviteLimit: number;
  maxVideoDurationSeconds: number;
};

type ApiResponse = {
  data: UserSettings;
  message: string;
};

export const getUserSettings = async (): Promise<UserSettings> => {
  try {
    const response = await axios.get<ApiResponse>("/users/settings/goalngo");
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch user settings");
  }
};

export type UserSubscription = {
  subscription?: {
    id: number;
    startDate: string;
    endDate: string;
    status: string;
    additionalProperties: any;
    subscriptionPlan: SubscriptionPlanOption;
    user: User;
  };
  freePlan?: SubscriptionPlanOption;
  reactivationOffer?: {
    eligible: boolean;
    reason: string;
  };
};

export const checkUserSubscription = async (): Promise<UserSubscription> => {
  try {
    const response = await axios.get("/subscriptions/check-user-subscription");
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to check user subscription");
  }
};
